import React from 'react';
import PublicLayout from './PublicLayout';

export default function CookiesPage() {
  return (
    <PublicLayout title="Cookies Policy" eyebrow="Legal" lastUpdated="February 18, 2026">
      <p>ScensobConnect uses cookies and similar storage technologies (localStorage, sessionStorage) to operate the Services.</p>
      <h2>Strictly necessary</h2>
      <ul>
        <li><strong>Authentication token</strong> — keeps you signed in between page loads.</li>
        <li><strong>CSRF protection</strong> — prevents cross-site request forgery.</li>
        <li><strong>Session preferences</strong> — your last-used filter, role view, etc.</li>
      </ul>
      <p>These cannot be disabled without breaking core functionality.</p>
      <h2>Analytics</h2>
      <p>We use minimal first-party analytics to measure adoption and identify usability issues. We do not run third-party advertising cookies. You can disable analytics in <em>Profile → Settings → Privacy</em>.</p>
      <h2>How to manage cookies</h2>
      <p>You can clear cookies and storage from your browser at any time. Doing so will sign you out of ScensobConnect.</p>
      <h2>Contact</h2>
      <p>Questions: <a href="mailto:privacy@scensobconnect.com">privacy@scensobconnect.com</a>.</p>
    </PublicLayout>
  );
}
